import { Table, notification } from 'antd';
import copy from 'copy-to-clipboard';
import union from 'lodash/union';
import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import './CompaniesTable.scss';

const CompaniesTable = ({ companies, withAction, dataSource, ...props }) => {
  const businesses = union(dataSource.map((element) => element.companyId));
  const onClickCopy = (value) => {
    copy(value);
    notification.success({ message: 'Copied' });
  };
  const handleRowClassName = (record) => {
    return Number(businesses.findIndex((business) => business === record.companyId)) % 2 === 0
      ? 'table-row-dark'
      : 'table-row-light';
  };
  const columns = [
    {
      title: 'Companies',
      dataIndex: 'companyId',
      key: 'companyId',
      fixed: 'left',
      width: 220,
      className: 'business-name',
      render: (value, row) => {
        const index = dataSource.findIndex((element) => element.id === row.id);
        const company = companies?.find((cp) => cp.id === value);
        const obj = {
          children: (
            <div className="flex justify-between items-center">
              <Link to={`/companies/${value}`} className="flex items-center">
                <div className="logo">
                  <img src={company?.logoThumbUrl || company?.logoUrl} />
                </div>
                <div className="ml-2">{company?.name}</div>
              </Link>
            </div>
          ),
          props: {
            rowSpan: dataSource.filter((item) => item.companyId === value).length,
          },
        };
        if (index === 0) return obj;
        if (dataSource[index - 1].companyId === value) {
          obj.props.rowSpan = 0;
          return obj;
        }
        return obj;
      },
    },
    {
      title: 'Location ID',
      dataIndex: 'locationId',
      className: 'id-copy',
      width: 150,
      key: 1,
      render: (value) => {
        return (
          <div onClick={() => onClickCopy(value)}>
            {value}
            <img src="/icons/file_copy.svg" />
          </div>
        );
      },
    },
    {
      title: 'Location Type',
      dataIndex: 'locationType',
      key: 2,
    },
    {
      title: 'Location name',
      dataIndex: 'name',
      width: 170,
      key: 3,
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 4,
      render: (value) => {
        return <div className="region-companies region-td">{value}</div>;
      },
    },
    {
      title: 'Address',
      dataIndex: 'address',
      width: 700,
      key: 5,
    },
    {
      title: 'Contact Person',
      dataIndex: 'name',
      key: 7,
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone',
      key: 7,
      width: 180,
    },
    {
      title: 'Debtor ID',
      dataIndex: 'companyId',
      key: 8,
      width: 180,
      render: (value) => {
        const company = companies?.find((cp) => cp.id === value);
        const obj = {
          children: company?.debtorId,
        };
        return obj;
      },
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      fixed: 'right',
      width: 100,
      key: 6,
      render: (value) => {
        const status = value ? 'Active' : 'Inactive';
        return <span className={'status companies ' + status.toLowerCase()}>{status}</span>;
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 180,
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  return (
    <div className="table-companies table-common ">
      <Table
        columns={columns}
        scroll={{ x: 2400 }}
        dataSource={dataSource}
        rowClassName={handleRowClassName}
        {...props}
      />
    </div>
  );
};

export default CompaniesTable;
